export default __webpack_public_path__ + "static/media/15.ce0c6322.jpg";